/**
 * PVE Template log.
 * 
 * @todo @export
 *
 * @interface PveTemplateLog
 */
interface PvETemplateLog {

  /** PvE Template log id. */
  _id: string;

  /** Creation date as ISO string. */
  created: string;

  /** New state. */
  newState: string;

  /** Old state. */
  oldSate: string;

  /** Log text. */
  text: string;

  /** Use who created or editted the template. */
  userId: User['_id'];
};
